export { default as mediaService } from './media.service';
